// Carrito lateral de SRJ: reemplaza al aviso de Dawn. product-form.js lo encuentra como <srj-carrito> y le pasa la respuesta.
(function () {
  if (customElements.get('srj-carrito')) return;

  var pesos = function (centavos) { return '$U' + Math.round(centavos / 100).toLocaleString('es-UY'); };
  var esPiso = function (item) { return (item.handle || '').indexOf('piso-vinilico-spc') !== -1; };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
  var conAncho = function (url, w) { if (!url) return ''; return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; };

  customElements.define('srj-carrito', class SrjCarrito extends HTMLElement {
    connectedCallback() {
      // vive dentro del encabezado (que es sticky y arma su propia capa): se pasa al <body> para quedar arriba de todo
      if (this.parentNode !== document.body) { document.body.appendChild(this); return; }
      if (this.listo) return;
      this.listo = true;
      var self = this;
      this.panel = this.querySelector('.srj-cl__panel');
      this.lista = this.querySelector('[data-srj-cl-lista]');
      this.addEventListener('click', function (e) {
        var paso = e.target.closest('[data-srj-cl-sug-paso]');
        if (paso) {
          var ni = paso.parentNode.querySelector('[data-srj-cl-sug-n]');
          ni.value = Math.max(0, (parseInt(ni.value, 10) || 0) + parseInt(paso.getAttribute('data-srj-cl-sug-paso'), 10));
          ni.closest('.srj-cl__sug-accion').querySelector('[data-srj-cl-sug-agregar]').disabled = !(+ni.value >= 1);
          return;
        }
        var b = e.target.closest('[data-srj-cl-sug-agregar]');
        if (!b || b.disabled) return;
        b.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: +b.getAttribute('data-srj-cl-sug-agregar'), quantity: parseInt(b.parentNode.querySelector('[data-srj-cl-sug-n]').value, 10) || 0 }) })
          .then(function (r) { return r.json(); })
          .then(function (item) { self.agregado = item && item.key ? item : null; self.cargar(); })
          .catch(function () { b.disabled = false; });
      });
      var zs = this.querySelector('[data-srj-cl-zona]');
      if (zs) zs.addEventListener('change', function () { self.zona(zs.value); });
      this.addEventListener('input', function (e) {
        if (!e.target.hasAttribute('data-srj-cl-sug-n')) return;
        e.target.closest('.srj-cl__sug-accion').querySelector('[data-srj-cl-sug-agregar]').disabled = !((parseInt(e.target.value, 10) || 0) >= 1);
      });
      this.querySelectorAll('[data-srj-cl-cerrar]').forEach(function (b) { b.addEventListener('click', function () { self.cerrar(); }); });
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.cerrar(); });
      // el ícono del carrito del encabezado abre el carrito lateral en vez de ir a /cart
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('#cart-icon-bubble');
        if (!a || e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        self.activo = a;
        self.abrir();
      });
      // cambios de cantidad y quitar
      this.lista.addEventListener('click', function (e) {
        var b = e.target.closest('[data-srj-cl-cambio]');
        if (!b) return;
        var fila = b.closest('[data-key]');
        var actual = parseInt(fila.dataset.cantidad, 10);
        var nueva = b.dataset.srjClCambio === 'quitar' ? 0 : Math.max(0, actual + parseInt(b.dataset.srjClCambio, 10));
        self.cambiar(fila.dataset.key, nueva);
      });
      this.lista.addEventListener('change', function (e) {
        var i = e.target.closest('[data-srj-cl-cantidad]');
        if (!i) return;
        var n = parseInt(i.value, 10);
        self.cambiar(i.closest('[data-key]').dataset.key, isNaN(n) || n < 0 ? 0 : n);
      });
    }

    // lo que pide product-form.js de Dawn
    getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
    setActiveElement(el) { this.activo = el; }
    renderContents(respuesta) {
      this.agregado = respuesta && respuesta.key ? respuesta : null;
      this.abrir();
    }

    abrir() {
      var self = this;
      this.hidden = false;
      document.body.classList.add('overflow-hidden', 'srj-cl-abierto');
      requestAnimationFrame(function () { self.classList.add('is-abierto'); self.panel.focus(); });
      this.entrega();
      if (!this.reloj) this.reloj = setInterval(function () { self.entrega(); }, 1000);
      this.cargar();
    }
    cerrar() {
      var self = this;
      this.classList.remove('is-abierto');
      clearInterval(this.reloj); this.reloj = null;
      document.body.classList.remove('overflow-hidden', 'srj-cl-abierto');
      setTimeout(function () { if (!self.classList.contains('is-abierto')) self.hidden = true; }, 300);
      if (this.activo && this.activo.focus) this.activo.focus();
    }

    cargar() {
      var self = this;
      this.classList.add('is-cargando');
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { return self.conListas(c); })
        .then(function (c) { self.pintar(c); })
        .finally(function () { self.classList.remove('is-cargando'); });
    }
    // cart.js no trae el precio de lista: se busca en /products/<handle>.js (una vez por producto)
    conListas(c) {
      var cache = this.listas || (this.listas = {});
      var faltan = c.items.filter(function (it) { return !(it.handle in cache); }).map(function (it) { return it.handle; });
      faltan = faltan.filter(function (h, i) { return faltan.indexOf(h) === i; });
      return Promise.all(faltan.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          cache[h] = {};
          if (p && p.variants) p.variants.forEach(function (v) { cache[h][v.id] = v.compare_at_price || 0; });
        }).catch(function () { cache[h] = {}; });
      })).then(function () {
        c.items.forEach(function (it) { it.compare_at_price = (cache[it.handle] || {})[it.variant_id] || 0; });
        return c;
      });
    }
    cambiar(key, cantidad) {
      var self = this;
      this.classList.add('is-cargando');
      this.agregado = null;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: cantidad })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.items) return self.conListas(c).then(function (cc) { self.pintar(cc); }); return self.cargar(); })
        .finally(function () { self.classList.remove('is-cargando'); });
    }

    // cuenta regresiva de entrega (assets/srj-entrega.js); corre solo con el carrito abierto
    entrega() {
      if (!window.srjEntrega) return;
      var e = window.srjEntrega();
      this.querySelector('[data-srj-cl-entrega-texto]').textContent = e.texto;
      this.querySelector('[data-srj-cl-entrega-avance]').style.width = e.avance + '%';
    }

    pintar(c) {
      var self = this;
      var q = function (s) { return self.querySelector(s); };
      // contador del encabezado
      document.querySelectorAll('.srj-carrito__contador span[aria-hidden]').forEach(function (s) { s.textContent = c.item_count; });
      q('[data-srj-cl-cuenta]').textContent = c.item_count ? '(' + c.items.length + ')' : '';

      var vacio = !c.items.length;
      q('[data-srj-cl-vacio]').hidden = !vacio;
      q('[data-srj-cl-pie]').hidden = vacio;
      this.lista.hidden = vacio;

      // sin aviso de "Agregaste…": lo recién agregado se marca con el borde verde de la foto (pedido de Ronald, 19/10/2026)

      var ahorro = 0;
      this.lista.innerHTML = c.items.map(function (it) {
        var piso = esPiso(it);
        var lista = (it.compare_at_price || 0) > it.price ? it.compare_at_price : 0;
        if (lista) ahorro += (lista - it.price) * it.quantity;
        var variante = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="srj-cl__variante">' + esc(it.variant_title) + '</span>' : '';
        var unidad = piso ? pesos(it.price) + ' el m²' : pesos(it.price) + ' c/u';
        var nuevo = self.agregado && self.agregado.key === it.key ? ' is-nuevo' : '';
        return '<div class="srj-cl__item' + nuevo + '" data-key="' + esc(it.key) + '" data-cantidad="' + it.quantity + '">' +
          '<a class="srj-cl__foto" href="' + esc(it.url) + '"><img src="' + esc(conAncho(it.image, 160)) + '" width="80" height="80" alt="" loading="lazy"></a>' +
          '<div class="srj-cl__datos">' +
            '<a class="srj-cl__nombre" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variante +
            '<span class="srj-cl__unidad">' + unidad + (lista ? ' <s>' + pesos(lista) + '</s>' : '') + '</span>' +
            '<div class="srj-cl__fila">' +
              '<div class="srj-cl__cantidad">' +
                '<button type="button" data-srj-cl-cambio="-1" aria-label="Menos">−</button>' +
                '<input type="number" min="0" inputmode="numeric" value="' + it.quantity + '" data-srj-cl-cantidad aria-label="Cantidad' + (piso ? ' en m²' : '') + '">' +
                '<button type="button" data-srj-cl-cambio="1" aria-label="Más">+</button>' +
              '</div>' + (piso ? '<span class="srj-cl__m2">m²</span>' : '') +
              '<strong class="srj-cl__precio">' + pesos(it.final_line_price) + '</strong>' +
            '</div>' +
            '<button type="button" class="srj-cl__quitar" data-srj-cl-cambio="quitar">Quitar</button>' +
          '</div>' +
        '</div>';
      }).join('');

      q('[data-srj-cl-total]').textContent = pesos(c.total_price);
      q('[data-srj-cl-cuota]').textContent = pesos(c.total_price / 12);
      var ah = q('[data-srj-cl-ahorro]');
      ah.hidden = !ahorro;
      if (ahorro) q('[data-srj-cl-ahorro-n]').textContent = pesos(ahorro);

      this.carrito = c;
      var zs = q('[data-srj-cl-zona]');
      var guardada = (c.attributes || {})['Zona de envío'] || '';
      if (zs && guardada && zs.value !== guardada) zs.value = guardada;
      q('[data-srj-cl-zona-fila]').hidden = vacio;
      this.pintarGratis();
      this.sugerir(c);
    }

    // Accesorios del piso SPC del mismo color (mismo orden que la ficha; zócalo blanco último), los que no estén ya en el carrito; sin stock se ven apagados.
    sugerir(c) {
      var self = this, caja = this.querySelector('[data-srj-cl-sug]');
      if (!caja) return;
      var piso = c.items.filter(esPiso)[0];
      if (!piso) { caja.hidden = true; return; }
      var color = piso.handle.replace('piso-vinilico-spc-', '');
      var handles = ['zocalo-spc-', 'perfil-t-spc-', 'reductor-spc-', 'remate-de-borde-spc-'].map(function (h) { return h + color; }).concat('zocalo-blanco-eps');
      var enCarrito = c.items.map(function (it) { return it.handle; });
      handles = handles.filter(function (h) { return enCarrito.indexOf(h) === -1; });
      this.prods = this.prods || {};
      Promise.all(handles.map(function (h) {
        if (h in self.prods) return self.prods[h];
        return (self.prods[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
      })).then(function (ps) {
        // se muestran todos; los que no tienen stock dicen "Sin stock" y se habilitan solos cuando se carga stock en Shopify
        var ok = ps.filter(function (p) { return p && p.variants && p.variants[0]; });
        caja.hidden = !ok.length;
        caja.querySelector('[data-srj-cl-sug-lista]').innerHTML = ok.map(function (p) {
          var v = p.variants[0];
          // medidas de Ronald: tira de 2,4 m (a tono) y 2,9 m (zócalo blanco). La cantidad la elige el cliente: arranca en 0, sin sugerencias.
          var largo = p.handle === 'zocalo-blanco-eps' ? 2.9 : 2.4;
          var nota = 'tira de ' + String(largo).replace('.', ',') + ' m';
          return '<div class="srj-cl__sug-item">' +
            '<a class="srj-cl__sug-foto" href="/products/' + esc(p.handle) + '"><img src="' + esc(conAncho(p.featured_image, 120)) + '" width="48" height="48" alt="" loading="lazy"></a>' +
            '<div class="srj-cl__sug-datos"><a href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a><span>' + pesos(v.price) + ' c/u · ' + nota + '</span>' +
              (!v.available ? '<div class="srj-cl__sug-accion"><button type="button" class="srj-cl__sug-agregar" disabled>Sin stock</button></div>' :
              '<div class="srj-cl__sug-accion">' +
                '<div class="srj-cl__cantidad srj-cl__sug-cant"><button type="button" data-srj-cl-sug-paso="-1" aria-label="Menos">−</button>' +
                '<input type="number" min="0" inputmode="numeric" value="0" data-srj-cl-sug-n aria-label="Cantidad">' +
                '<button type="button" data-srj-cl-sug-paso="1" aria-label="Más">+</button></div>' +
                '<button type="button" class="srj-cl__sug-agregar" data-srj-cl-sug-agregar="' + v.id + '" disabled>Agregar</button>' +
              '</div>') +
            '</div>' +
          '</div>';
        }).join('');
      });
    }

    // Envío gratis y zona: Montevideo y alrededores tienen la barra; otro lugar, "lo coordinamos por WhatsApp"; retiro, dirección y horario.
    pintarGratis() {
      var self = this, c = this.carrito;
      var q = function (s) { return self.querySelector(s); };
      var gr = q('[data-srj-cl-gratis]'), co = q('[data-srj-cl-coordinar]'), zs = q('[data-srj-cl-zona]');
      if (!gr || !c) return;
      this.pintarEnvio();
      var vacio = !c.items.length;
      var op = zs && zs.selectedOptions[0], tipo = op && op.getAttribute('data-tipo') || '';
      var meta = parseFloat(gr.getAttribute('data-srj-cl-gratis')) * 100;
      co.hidden = vacio || tipo !== 'lejos';
      q('[data-srj-cl-retiro]').hidden = vacio || tipo !== 'retiro';
      if (tipo === 'lejos') q('[data-srj-cl-coordinar-texto]').textContent = op.value === 'Otro lugar de Canelones'
        ? 'Antes de comprar, consultanos por WhatsApp si llegamos a tu zona.'
        : 'Al interior enviamos por agencia. Terminás la compra acá y después te escribimos por WhatsApp para coordinar el envío.';
      if (tipo === 'lejos') q('[data-srj-cl-coordinar-link]').hidden = op.value !== 'Otro lugar de Canelones';
      // con retiro no corre la cuenta regresiva de entrega
      var ent = q('[data-srj-cl-entrega]');
      if (ent) ent.hidden = tipo === 'retiro';
      gr.hidden = vacio || !meta || tipo === 'lejos' || tipo === 'retiro';
      if (gr.hidden) return;
      var donde = tipo === 'cerca' ? (op.value === 'Montevideo' ? 'en Montevideo' : 'a ' + op.value) : 'en Montevideo y alrededores';
      var falta = meta - c.total_price;
      gr.classList.toggle('is-lograda', falta <= 0);
      q('[data-srj-cl-gratis-texto]').innerHTML = falta > 0
        ? 'Te faltan <strong>' + pesos(falta) + '</strong> para tener <strong>envío gratis</strong> ' + esc(donde)
        : '<strong>¡Tenés envío gratis!</strong> ' + esc(donde);
      q('[data-srj-cl-gratis-relleno]').style.width = Math.min(100, c.total_price / meta * 100) + '%';
      // Canelones cercano: se paga en la web igual que Montevideo ($650 en la tienda), gratis desde el mismo monto
      var nota = q('[data-srj-cl-gratis-nota]'), canel = op && op.hasAttribute('data-canelones');
      var flete = parseFloat(gr.getAttribute('data-srj-cl-flete-cerca'));
      nota.hidden = !canel || falta <= 0;
      if (canel && falta > 0) nota.textContent = 'Si no, el envío a ' + op.value + ' es ' + pesos(flete * 100) + '.';
    }

    // Fila de envío del pie y total: Montevideo y Canelones cercano suman el envío (se cobra en la web); el resto no cambia el total.
    pintarEnvio() {
      var self = this, c = this.carrito;
      var q = function (s) { return self.querySelector(s); };
      var fila = q('[data-srj-cl-envio-fila]'), zs = q('[data-srj-cl-zona]'), gr = q('[data-srj-cl-gratis]');
      if (!fila || !c) return;
      var op = zs && zs.selectedOptions[0], tipo = op && op.getAttribute('data-tipo') || '';
      var meta = parseFloat(gr.getAttribute('data-srj-cl-gratis')) * 100;
      var gratis = c.total_price >= meta;
      var et, monto, suma = 0;
      if (tipo === 'retiro') { et = 'Retiro en el local'; monto = '<strong class="srj-cl__gratis-si">Gratis</strong>'; }
      else if (tipo === 'lejos') { et = 'Envío'; monto = 'Lo coordinamos por WhatsApp'; }
      else if (tipo === 'cerca' && op.value === 'Montevideo') {
        var mvd = parseFloat(fila.getAttribute('data-srj-cl-envio-mvd')) * 100;
        et = 'Envío a Montevideo';
        if (gratis) monto = '<strong class="srj-cl__gratis-si">Gratis</strong>'; else { monto = pesos(mvd); suma = mvd; }
      } else if (tipo === 'cerca') {
        var can = parseFloat(gr.getAttribute('data-srj-cl-flete-cerca')) * 100;
        et = 'Envío a ' + esc(op.value);
        if (gratis) monto = '<strong class="srj-cl__gratis-si">Gratis</strong>'; else { monto = pesos(can); suma = can; }
      } else { et = 'Envío'; monto = 'Elegí tu zona arriba'; }
      q('[data-srj-cl-envio-et]').innerHTML = et;
      q('[data-srj-cl-envio-monto]').innerHTML = monto;
      q('[data-srj-cl-total]').textContent = pesos(c.total_price + suma);
      q('[data-srj-cl-cuota]').textContent = pesos((c.total_price + suma) / 12);
    }

    zona(valor) {
      var self = this;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Zona de envío': valor } }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (self.carrito && c && c.attributes) self.carrito.attributes = c.attributes; })
        .catch(function () {});
      this.pintarGratis();
    }
  });
})();
